"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Donuts = void 0;
var Donuts = /** @class */ (function () {
    function Donuts(base) {
        this.base = base;
        this.setModel();
    }
    Donuts.prototype.setModel = function () {
        this.scene = this.base.resources.donutsModel.scene;
        this.base.scene.add(this.scene);
        this.scene.scale.set(45, 45, 45);
        this.scene.position.set(2, 0, 0);
        this.scene.rotation.x = Math.PI * 0.3;
        this.scene.rotation.z = Math.PI * 0.15;
    };
    Donuts.prototype.update = function (clock) {
        this.scene.rotation.y = clock.getElapsedTime();
    };
    return Donuts;
}());
exports.Donuts = Donuts;
